// apps/vrw-cp
// 軌道情報を表示するページコンポーネント
import React, { useState } from "react";
import { Typography, Button } from "@mui/material";

import { MissionReadResponse } from "@/lib/models/mission";
import MainBox from "@/components/common/MainBox";
import SatellitesOrbit3D from "@/components/SatellitesOrbit3D";
import { Link } from "@/components/Link";

const App = ({ item }: { item: MissionReadResponse }) => {
  const missionPage = `/q/${item.type}/i/${item.pk}`;
  const celestrackUrl = `https://celestrak.org/NORAD/elements/table.php?INTDES=${item.launch_designator}`;
  const [useEarthFixed, setUseEarthFixed] = useState(true);

  // 表示モードを地表固定に切り替える
  const activateEarthFixed = () => setUseEarthFixed(true);

  // 表示モードを地球外（慣性）座標に切り替える
  const activateInertial = () => setUseEarthFixed(false);

  return (
    <>
      <MainBox>
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          <Link href={missionPage}>{item.title}</Link>
        </Typography>
        {item.launch_designator?.length ? (
          <Typography variant="body2" sx={{ textAlign: "center" }}>
            識別符号: {item.launch_designator}{" "}
            <Link href={celestrackUrl} external>
              celestrack.org
            </Link>
          </Typography>
        ) : (
          <Typography variant="body2" sx={{ textAlign: "center" }}>
            識別符号がありません
          </Typography>
        )}
      </MainBox>
      <MainBox>
        <Button
          variant={useEarthFixed ? "contained" : "outlined"}
          onClick={activateEarthFixed}
          disabled={useEarthFixed}
          sx={{ mb: 1, mr: 1 }}
        >
          地表座標に切り替え
        </Button>
        <Button
          variant={!useEarthFixed ? "contained" : "outlined"}
          onClick={activateInertial}
          disabled={!useEarthFixed}
          sx={{ mb: 1 }}
        >
          地球外座標に切り替え
        </Button>
        <SatellitesOrbit3D
          tles={item.tle_list?.map((tle: string) => tle.split("\n") || [])}
          useEarthFixed={useEarthFixed}
        />
      </MainBox>
    </>
  );
};

export default App;
